import React from 'react';

import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';

import LoadingSpinner from 'static/three-oh/src/components/LoadingSpinner/LoadingSpinner';
import {adminBinderRoot} from 'static/three-oh/src/modules/constants/routePaths';

const LazyAdminBinderContainer = Loadable({
  loader: () => import('./containers/AdminBinderContainer'),
  loading: LoadingSpinner,
});

const AdminBinderRoute = [
  <Route
    key="AdminBinderCatchAll"
    path={adminBinderRoot}
    component={LazyAdminBinderContainer}
  />,
];

export default AdminBinderRoute;
